import { getFirst, isValidWithoutData } from 'clients/Clients';
import UploadFileClient from 'clients/UploadFileClient';
import { ChangeEvent, useState } from 'react';
import NotifyUtils from 'utils/NotifyUtils';

interface Props {
  maxFileSize?: number; // MB
  callback?: (url: string) => void | Promise<boolean>;
}

export const useUploadSingleFile = ({ maxFileSize = 5, callback }: Props) => {
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const onChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (file.size > maxFileSize * 1024 * 1024) {
        NotifyUtils.error(`Kích thước tối đa ${maxFileSize}MB`);
        return;
      }
      // Call your function here with the selected file

      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result as string;

        const body = {
          file: base64String,
          type: file.type,
        };
        setIsLoading(true);
        const result = await UploadFileClient.upload({ body, ctx: undefined });

        if (result?.status === "ERROR") {
          setIsLoading(false);
          NotifyUtils.error('Tải file không thành công. Vui lòng thử lại sau.');
          return;
        }

        if (!isValidWithoutData) {
          setIsLoading(false);
          NotifyUtils.error(result?.message || 'Tải file không thành công');
          return;
        }

        const uploadedUrl = getFirst(result);

        // Call the callback function if it exists
        // The callback function should return a boolean value
        // If the callback function returns true, the url will be set
        if (callback) {
          if (typeof callback === 'function') {
            const result = callback(uploadedUrl);
            if (result instanceof Promise) {
              await result
                .then((res) => {
                  if (res) {
                    setUrl(uploadedUrl);
                  }
                })
                .finally(() => {
                  setIsLoading(false);
                });

              return;
            }
            callback(uploadedUrl);
          } else {
            console.error('Callback is not a function');
          }
        }

        setUrl(uploadedUrl);
        setIsLoading(false);

        // You can now use the base64String as needed
      };
      reader.readAsDataURL(file);
    }
  };

  return {
    url,
    isLoading,
    setUrl,
    setIsLoading,
    onChange,
  };
};

